import React from "react";
import { Div, Text, Button, Image, Anchor } from "atomize";
import CustomContainer from "../common/CustomContainer";
import { OutboundLink } from "gatsby-plugin-google-gtag"

export default function HeroSection() {
  return (
    <Div m={{ t: '-72px' }} className="overflow-x-hidden hero-section" tag="section" id="hero" data-scroll-section data-scroll-position="top" pos="relative" zIndex="1" p={{ b: { sm: '3rem', md: '7rem', lg: '2.8rem' } }}>
      {/* Bg Images with noise */}
      <Div data-scroll data-scroll-speed="-0.5" data-scroll-position="top" pos="absolute" top={{ xs: "0", sm: '-40%', md: '0' }} left="0" right="0">
        <Image d={{ xs: 'none', md: 'block' }} src="/images/grain/hero-bg-desktop.jpg" alt="hero-bg-desktop" />
        <Image d={{ xs: 'block', md: 'none' }} src="/images/grain/hero-bg-mobile.jpg" alt="hero-bg-mobile" />
        <Div className="noise img" />
      </Div>
      {/* Main Component */}
      <CustomContainer pos="relative" zIndex="1" overflow="visible">
        <Div p={{ xs: "10.125rem 0 0", lg: '14rem 0 6rem', xl: "18vw 0" }} overflow="visible" d="flex" align="center" flexWrap="wrap">
          <Div m="0 auto" p={{ b: { lg: '2.5rem' } }} w={{ xs: '20rem', sm: '23rem', md: '20rem', lg: '27rem', xl: "40rem" }} d="flex" flexDir="column" align={{ xs: "center", md: "flex-start" }}>
            <Div d="flex">
              <Image
                src="/images/icons/logo-full.svg"
                h={{ xs: "40px", lg: "48px", xl: "78px" }}
                w="auto"
                alt="full-logo"
              />
            </Div>
            <Text
              tag="h2"
              textWeight="400"
              fontFamily="tertiary"
              textSize={{ xs: "paragraph", lg: "subtitle", xl: "subheader" }}
              textAlign={{ xs: 'center', md: 'left' }}
              m={{ xs: "1.25rem 0 1.5rem", lg: "2rem 0 2.5rem" }}
              className="hero-section-description-text"
            >
              A pack of playful geometric 3D shapes, customizable for your design projects.
            </Text>
            <OutboundLink href="https://gumroad.com/l/3dmade" target="_blank" >
              <Button
                type="button"
                h="4rem"
                maxW="100%"
                textColor="white"
                rounded="0"
                fontFamily="secondary"
                textWeight="600"
                justify="space-between"
                p={{ xs: "1rem 1.75rem", lg: "1rem 2rem" }}
                w={{ xs: "16rem", lg: "21.5rem" }}
                className="hero-button"
                suffix={
                  <Image
                    src="/images/icons/arrow.svg"
                    m={{ l: { xs: "1rem", lg: "1.5rem" } }}
                    w={{ xs: "1.5rem", lg: "2rem" }}
                    h="auto"
                  />
                }
              >
                Get the pack now
              </Button>
            </OutboundLink>
          </Div>
          <Div pos="relative" overflow="visible" flexGrow={{ xs: '1 0 100%', md: '1' }} d="flex" flexDir="column" align="center">
            {/* For mobile */}
            {/* <Div overflow="visible" d={{ xs: 'block', md: 'none' }} m={{ t: '3.5rem' }} pos="relative" p={{ b: "75%" }}>
              {mobileShapes.map(image => (
                <Image pos="absolute" {...image} />
              ))}
            </Div> */}
            {/* For desktop */}
            <Div overflow="visible" pos="relative" w={{ xs: "116%", md: "100%" }}>
              <Div overflow="visible" m={{ t: { xs: '2.5rem', md: "0" } }} pos={{ xs: "relative", md: "absolute" }} left="0" right="0" top="50%" transform={{ xs: "translateX(1.5%)", md: "translateY(-50%)" }} p={{ b: '84%' }}>
                {desktopShapes.map(image => (
                  <Image data-scroll data-scroll-position="top" pos="absolute" {...image} />
                ))}
              </Div>
            </Div>
          </Div>
        </Div>
      </CustomContainer>
    </Div>
  );
}

const desktopShapes = [{
  src: "/images/hero-shapes/half-tube-shape.png",
  top: "53%",
  w: "31.5%",
  left: "0",
  "data-scroll-speed": "1.25",
}, {
  src: "/images/hero-shapes/cone-shape.png",
  bottom: "1%",
  w: "23.5%",
  left: "38.95%",
  "data-scroll-speed": "1.75",
}, {
  src: "/images/hero-shapes/zig-zag-shape.png",
  top: "13%",
  w: "44%",
  left: "3%",
  "data-scroll-speed": "2.5",
}, {
  src: "/images/hero-shapes/hemisphere-shape.png",
  top: "35.6%",
  w: "41.7%",
  right: "0",
  "data-scroll-speed": "3",
}, {
  src: "/images/hero-shapes/capsule-shape.png",
  top: "0%",
  w: "28.5%",
  left: "43%",
  "data-scroll-speed": "1.25",
}];


// const mobileShapes = [{
//   src: "/images/hero-shapes/half-tube-shape.png",
//   top: "42.77%",
//   w: "27.45%",
//   left: "-8.82%",
//   alt: "half-tube-shape",
// }, {
//   src: "/images/hero-shapes/cone-shape.png",
//   top: "36.3%",
//   w: "20.5%",
//   left: "45.9%",
//   alt: "cone-shape",
// }, {
//   src: "/images/hero-shapes/zig-zag-shape.png",
//   top: "4.6%",
//   w: "39.2%",
//   left: "0%",
//   alt: "zig-zag-shape",
// }, {
//   src: "/images/hero-shapes/hemisphere-shape.png",
//   top: "46.8%",
//   w: "35.8%",
//   left: "72.9%",
//   alt: "hemisphere-shape",
// }, {
//   src: "/images/hero-shapes/capsule-shape.png",
//   top: "2.5%",
//   w: "23.9%",
//   left: "59.7%",
//   transform: "rotate(170deg)",
//   alt: "capsule-shape",
// }, {
//   src: "/images/hero-shapes/disk-shape.png",
//   top: "67.97%",
//   w: "15.7%",
//   left: "23.5%",
//   transform: "rotate(25.72deg)",
//   alt: "disk-shape",
// }];
